import React, { useEffect, useState, useCallback, ChangeEvent } from "react";
import { Button, Card, MenuItem, useTheme, IconButton } from "@mui/material";
import NiceModal from "@ebay/nice-modal-react";
import { useSelector } from "src/store/Store";
import { PageContainer, Breadcrumb } from "../common";
import Loading from "../common/Loading";
import { selectUserCompany } from "src/store/authSlice";
import { client } from "src/common/axiosClient";
import Modal from "../common/Modal";
import { useNavigate } from "react-router";
import moment from "moment";

import { Add, Edit, Delete } from "@mui/icons-material";
import DoctorMetaTable from "./DoctorMetaTable";

export default function DoctorList() {
  const navigate = useNavigate();
  const theme = useTheme();
  const borderColor = theme.palette.divider;

  const { companyId } = useSelector(selectUserCompany);

  const [isLoding, setLoding] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [activeButton, setActiveButton] = useState("card");

  //의사등록
  const [isInsertShow, setIsInsertShow] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [previewUrl, setPreviewUrl] = useState<any>(null);
  const [file, setFile] = useState<any>(null);

  //의사 수정
  const [isUpdateShow, setIsUpdateShow] = useState<boolean>(false);
  const [nameUpdate, setNameUpdate] = useState<string>("");
  const [choiceDoctorId, setChoiceDoctorId] = useState<number>(0);
  const [previewUrlUpdate, setPreviewUrlUpdate] = useState<any>(null);
  const [fileUpdate, setFileUpdate] = useState<any>(null);

  useEffect(() => {
    getDoctorList();
  }, []);

  //의사 이름
  const nameOnChange = (e: any) => {
    setName(e.target.value);
  };
  //의사 이름 수정
  const nameUpdateOnChange = (e: any) => {
    setNameUpdate(e.target.value);
  };

  const getDoctorList = async () => {
    setData([]);
    console.log("Request headers:", client.defaults.headers.common);
    const response = await client.get("admin/api/v1/medical-staff/DOCTOR");

    if (response.status === 200) {
      console.log(response);
      setData([...response.data.content]);
    } else {
      console.log(response);
    }
  };

  const doDelete = (id: number, index: number) => {
    client
      .delete(`admin/api/v1/medical-staff/DOCTOR/${id}`)
      .then((response) => {
        if (response.status === 200) {
          alert("의사가 삭제되었습니다.");
          getDoctorList();
        } else {
          alert("삭제에 실패했습니다.");
        }
      })
      .catch((error) => {
        console.error("There was an error deleting the doctor!", error);
        alert("삭제 중 오류가 발생했습니다.");
      });
    console.log("aaaa");
  };

  //의사 등록
  // 의사 미리보기
  const fileChangedHandler = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  //의사 모달창 닫기
  const setInsertShowModal = (value: boolean) => {
    if (value) {
      setIsInsertShow(value);
    } else {
      setIsInsertShow(value);
      setName("");
      setPreviewUrl(null);
      setFile(null);
      getDoctorList();
    }
  };
  //의사 모달창 닫기
  const insertDoctor = async () => {
    if (name !== "" && previewUrl !== "") {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("profileImageFile", file);

      const response = await client.post(
        "admin/api/v1/medical-staff/DOCTOR",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 201) {
        alert("의사등록이 완료되었습니다.");
        setInsertShowModal(false);
      }
    } else {
      alert("값을 입력해주세요");
    }
  };

  // 의사 등록
  // 의사 미리보기
  const fileUpdateChangedHandler = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      setFileUpdate(file);
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrlUpdate(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  //의사 모달창 닫기
  const setUpdateShowModal = (value: boolean, data?: any) => {
    console.log(data);
    if (value && data) {
      setNameUpdate(data.name);
      setChoiceDoctorId(data.id);
      setPreviewUrlUpdate(data.profileImageUrl);
      setIsUpdateShow(value);
    } else {
      setIsUpdateShow(value);
      setNameUpdate("");
      setPreviewUrlUpdate(null);
      setFileUpdate(null);
      getDoctorList();
    }
  };
  //의사 모달창 닫기
  const updateDoctor = async () => {
    if (nameUpdate !== "" && fileUpdate !== "") {
      const formData = new FormData();
      formData.append("name", nameUpdate);
      formData.append("profileImageFile", fileUpdate);

      const response = await client.post(
        `admin/api/v1/medical-staff/DOCTOR/${choiceDoctorId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 201) {
        alert("의사수정이 완료되었습니다.");
        setUpdateShowModal(false);
      }
    } else {
      alert("값을 입력해주세요");
    }
  };

  const days = ["월", "화", "수", "목", "금", "토", "일"];
  const times = ["9:00 ~ 13:00", "13:00 ~ 14:00", "14:00 ~ 18:00"];

  const schedule =
    // 여기에 각 카드의 스케줄 데이터를 배열로 추가하세요.
    // 예시: [[true, false, true], [false, true, false], ...]
    [
      [true, false, true],
      [false, true, false],
      [true, false, true],
      [false, true, false],
      [true, false, true],
      [false, true, false],
      [true, false, true],
    ];
  return (
    <>
      <PageContainer>
        <Loading isLoading={isLoding} />
        <Breadcrumb
          action={
            <div className="space-x-5">
              <Button
                variant="contained"
                size="small"
                onClick={() => setInsertShowModal(true)}
              >
                의사추가
              </Button>
            </div>
          }
        >
          <div className="flex items-center">
            <div>의사 관리</div>
          </div>
        </Breadcrumb>
        <div className="inline-flex rounded-md shadow-sm mb-5" role="group">
          <button
            type="button"
            onClick={() => setActiveButton("card")}
            className={`px-4 py-2 text-sm font-medium ${
              activeButton === "card"
                ? "text-blue-700 bg-gray-100"
                : "text-gray-900 bg-white"
            } border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700`}
          >
            카드
          </button>
          <button
            type="button"
            onClick={() => setActiveButton("list")}
            className={`px-4 py-2 text-sm font-medium ${
              activeButton === "list"
                ? "text-blue-700 bg-gray-100"
                : "text-gray-900 bg-white"
            } border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700`}
          >
            리스트
          </button>
        </div>
        {/* 기업 리스트 */}
        {activeButton === "card" ? (
          <Card sx={{ padding: "10px", border: `1px solid ${borderColor}` }}>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
              {data.map((doctorItem, index) => {
                //  {id:1, status:'대기', dayStatus:'경고', dDay:10, backgroundColor:'#D1T32'},
                return (
                  <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <div className="p-4 border border-gray-300 rounded-md shadow-md">
                      <div className="relative overflow-x-auto">
                        <div className="flex items-center justify-center">
                          <img
                            src={doctorItem.profileImageUrl}
                            className="max-w-xs max-h-48 rounded-lg border"
                            alt="Apple Watch"
                          />
                        </div>
                        <div className="flex gap-2 my-2 text-center justify-between">
                          <div className="text-lg font-bold mb-2">
                            {doctorItem.name}
                          </div>
                          <div className="flex gap-2">
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() =>
                                navigate(`/doctor/schedule?id=${doctorItem.id}`)
                              }
                            >
                              스케줄
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() =>
                                navigate(
                                  `/doctor/paidLeave?id=${doctorItem.id}`
                                )
                              }
                            >
                              연차
                            </Button>
                          </div>
                        </div>
                        <DoctorMetaTable id={doctorItem.id} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Card>
        ) : (
          <Card sx={{ padding: "10px", border: `1px solid ${borderColor}` }}>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
              <table className="w-full text-sm text-left text-gray-500 ">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
                  <tr>
                    <th className="px-6 py-3">No.</th>
                    <th className="px-6 py-3">이미지</th>
                    <th className="px-6 py-3">이름</th>
                    <th className="px-6 py-3">스케줄 관리</th>
                    <th className="px-6 py-3">등록일</th>
                    <th className="px-6 py-3">수정</th>
                    <th className="px-6 py-3">삭제</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((doctorItem, index) => (
                    <tr
                      key={index}
                      className="bg-white border-b  hover:bg-gray-50 "
                    >
                      <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap ">
                        {doctorItem.id}
                      </td>
                      <td className="w-32 p-4">
                        <img
                          src={doctorItem.profileImageUrl}
                          alt={doctorItem.name}
                          className="h-16 object-cover rounded-lg"
                        />
                      </td>
                      <td className="px-6 py-4">{doctorItem.name}</td>
                      <td className="px-6 py-4">
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() =>
                            navigate(`/doctor/schedule?id=${doctorItem.id}`)
                          }
                        >
                          스케줄
                        </Button>
                      </td>
                      <td className="px-6 py-4">
                        {moment(doctorItem.createdAt).format("YYYY-MM-DD")}
                      </td>
                      <td className="px-6 py-4">
                        <IconButton
                          color="primary"
                          onClick={() => setUpdateShowModal(true, doctorItem)}
                        >
                          <Edit />
                        </IconButton>
                      </td>
                      <td className="px-6 py-4">
                        <IconButton
                          color="error"
                          onClick={() => doDelete(doctorItem.id, index)}
                        >
                          <Delete />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        )}
      </PageContainer>
      <Modal
        isView={isInsertShow}
        title={"의사등록"}
        doAction={insertDoctor}
        cancelAction={() => setInsertShowModal(false)}
        doActionText={"등록"}
      >
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900">
            이름
          </label>
          <input
            type="text"
            value={name}
            onChange={nameOnChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          />
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900">
            의사사진
          </label>
          <input
            onChange={fileChangedHandler}
            className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
            type="file"
          />
          <div className="flex justify-center m-auto mt-5">
            {previewUrl && (
              <img
                src={previewUrl as string}
                alt="Preview"
                className="max-w-xs max-h-48 rounded-lg"
              />
            )}
          </div>
        </div>
      </Modal>

      <Modal
        isView={isUpdateShow}
        title={`의사수정`}
        doAction={updateDoctor}
        cancelAction={() => setUpdateShowModal(false)}
        doActionText={"수정"}
      >
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900">
            이름
          </label>
          <input
            type="text"
            value={nameUpdate}
            onChange={nameUpdateOnChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
          />
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900">
            의사사진
          </label>
          <input
            onChange={fileUpdateChangedHandler}
            className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
            type="file"
          />
          <div className="flex justify-center m-auto mt-5">
            {previewUrlUpdate && (
              <img
                src={previewUrlUpdate as string}
                alt="Preview"
                className="max-w-xs max-h-48 rounded-lg"
              />
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}
